export function useTrackEvent(
    name = null,
    data = {},
) {
    globalThis.dataLayer.push({
        event: name,
        ...data,
    });
}
